import React, { FC } from 'react'
import text from 'styles/utility/text.module.scss'
import { DefaultStockType } from 'types/schedule'

type Props = {
  defaultStock: DefaultStockType
  isUpdatedPickupableTime: boolean
  isUpdatedStock: boolean
}

const SettingsScheduleDefaultStock: FC<Props> = React.memo((props) => {
  const { defaultStock, isUpdatedPickupableTime, isUpdatedStock } = props

  return (
    <p className={`${text.font_small}`}>
      {isUpdatedPickupableTime ? (
        <span className={`${text.font_bold} ${text.color_caution}`}>{defaultStock.pickupable_time}</span>
      ) : (
        <span className={`${text.font_bold}`}>{defaultStock.pickupable_time}</span>
      )}
      に解禁される在庫数：
      {isUpdatedStock ? (
        <span className={`${text.font_bold} ${text.color_caution}`}>{defaultStock.stock}個</span>
      ) : (
        <span className={`${text.font_bold}`}>{defaultStock.stock}個</span>
      )}
    </p>
  )
})

export default SettingsScheduleDefaultStock
